import useBitumioMutation from "hooks/useBitumioMutation";
import { useCustomSegmentAiMappingRunAreaMutation } from "generated/graphql";

export const useSegmentAiMappingRunArea = () => {
  const [mutation, { data, loading, error }] = useCustomSegmentAiMappingRunAreaMutation();
  return useBitumioMutation(
    { mutation, loading, data, error, key: "segmentAiMappingRunArea" },
    { hideMessage: true }
  );
};
